import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_4: FaireProductEntity = {
  token: "atc_toast_4",
  type: "product",
  name: "Soy Wax Candle — Amber & Moss",
  brandName: "P.F. Candle Co.",
  imageUrl: "",
  priceDollars: 18.0,
  msrpDollars: 36.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
